module.exports = __webpack_public_path__ + "static/img/58.276b7bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/58.png
// module id = B9zo
// module chunks = 0